<div class="btn-cart">
    <a routerLink="carrinho" title="Carrinho de Compras" class="btn-header-action"> 
        <img defaultImage="/images/pixel/bg.png" lazyLoad="/images/template/icons/carrinho.svg" width="25px" height="25px" alt="Carrinho" />    
        <div class="text">  
            <span>Meu</span><br>
            <strong>Carrinho ({{qtd}})</strong>
        </div>
    </a>     
</div>
